module.exports = __webpack_public_path__ + "static/bottom-90225cedd17aadd6dabc5b9a986e988b.png";